/***
*
*   useEvents hook
*   fetch, format and return the events
*
**********/

import { useState, useEffect } from 'react';
import { useAPI } from 'components/lib';

export function useEvents(props) {

    const [state, setState] = useState({ data: null, loading: false });
    const events = useAPI('/api/event?search=&group=name');
    // const customEvents = useAPI(`/api/event?search=&offset=0&limit=25&name=signin&user=ac7850ee-76c3-4aa0-bc29-776d8b1cb0c6`)

    useEffect(() => {

        setState({ loading: true });

        const event = events.data?.results?.map(eventData => ({
            value: eventData.id, label: eventData.name
        })) || [];

        setState({ data: { list: event }, loading: false });

    }, [events]);

    return state;

}